// src/api/points.js

import api from './axios';

// ✅ 아래 두 함수 추가
/** 오늘의 출석체크 상태를 조회합니다. */
export const getCheckinStatus = () => api.get('/api/points/checkin/');

/** 출석체크를 실행합니다. */
export const postCheckin = () => api.post('/api/points/checkin/');